import { render, staticRenderFns } from "./HKOrderDetail.vue?vue&type=template&id=43f7184e"
import script from "./HKOrderDetail.vue?vue&type=script&lang=js"
export * from "./HKOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports